export function stringFitErrorMessage(error, greek = false) {
  let detail = error?.response?.data?.detail ?? error?.message ?? error;
  for (let i = 0; i < 3; i += 1) {
    if (typeof detail === "string") {
      try { detail = JSON.parse(detail); } catch { break; }
    } else if (detail && typeof detail === "object") detail = detail.detail ?? detail.message;
    else break;
  }
  const message = typeof detail === "string" ? detail : "";
  if (/No exact electrically valid arrangement|No valid string arrangement/.test(message)) return greek
    ? "Δεν βρέθηκε έγκυρη κατανομή strings για όλα τα πάνελ της κάτοψης με τους υπάρχοντες αντιστροφείς και τα συνδεδεμένα MPPT. Μειώστε τις θέσεις πάνελ ή αναθεωρήστε τον ηλεκτρολογικό σχεδιασμό. Δεν εφαρμόστηκε καμία αλλαγή."
    : "No electrically valid string arrangement was found for every panel in the plan with the existing inverters and connected MPPTs. Reduce the module positions or revise the electrical design. No changes were applied.";
  if (/Complete the equipment catalogue data/.test(message)) return greek
    ? "Συμπληρώστε τα απαραίτητα ηλεκτρικά στοιχεία του πλαισίου και του αντιστροφέα πριν από την προσαρμογή των strings. Δεν εφαρμόστηκε αλλαγή."
    : "Complete the required module and inverter electrical data before fitting strings. No changes were applied.";
  return greek
    ? "Η προσαρμογή των strings δεν ολοκληρώθηκε. Ελέγξτε τον εξοπλισμό και τον ηλεκτρολογικό σχεδιασμό και δοκιμάστε ξανά. Δεν εφαρμόστηκε αλλαγή."
    : "The strings could not be fitted. Check the equipment and electrical design and retry. No changes were applied.";
}
